import React from 'react';

import ButtonList from '@src/components/wysiwyg_editor/page_content_items/control_panels/ButtonList';
import Forward from '@src/components/wysiwyg_editor/page_content_items/control_panels/Forward';
import Backward from '@src/components/wysiwyg_editor/page_content_items/control_panels/Backward';
import Delete from '@src/components/wysiwyg_editor/page_content_items/control_panels/Delete';
import Zoom from '@src/components/wysiwyg_editor/page_content_items/control_panels/Zoom';
import Replace from '@src/components/wysiwyg_editor/page_content_items/control_panels/Replace';
import type { TImageContentItem } from '@src/types/wysiwyg_editor';
import { useDispatch } from 'react-redux';
import {
  deletePageContentItem,
  movePageContentItemBackward,
  movePageContentItemForward,
  saveSnapshot
} from '@src/actions/wysiwyg/editor';

type TProps = {
  itemData: TImageContentItem;
  onChangeClick: () => void;
  onZoomClick: () => void;
};

function MainPanel(props: TProps): React.ReactElement {
  const dispatch = useDispatch();

  return (
    <ButtonList>
      <Replace onClick={props.onChangeClick} />
      <Zoom onClick={props.onZoomClick} />
      <Forward
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(movePageContentItemForward(props.itemData.id));
        }}
      />
      <Backward
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(movePageContentItemBackward(props.itemData.id));
        }}
      />
      <Delete
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(deletePageContentItem(props.itemData.id));
        }}
      />
    </ButtonList>
  );
}

export default MainPanel;
